import React from "react";

import * as S from "./styles";

export const SandaliaValente: React.FC = () => {
  return (
    <S.Container>
      <S.WrapperPhoto>
        <S.Photo1
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
        <S.Photo1Legend>
          Benjamin Abrahão, Lampião e Maria Bonita, em 1936. Foto: Acervo IMS
        </S.Photo1Legend>
      </S.WrapperPhoto>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Sandália
            <br />
            valente
          </S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                O fato, porém, é que, antes mesmo de seguir as trilhas do
                comércio global e sem ainda ter se transformado na “sandália de
                Lampião”, a xô boi já servia à vaqueiragem e a todos que
                percorriam distâncias na aridez sertaneja.
              </p>

              <p>
                Apercata de couro e sola era um item de primeira necessidade nas
                vilas onde havia criação de gado, posto que, uma vez no encalço
                do boi que se perdeu do rebanho ou do garrote assustado em
                disparada, o calçado protegia os dedos e o dorso do pé dos
                vaqueiros contra a vegetação repleta de galhos secos, pontas
                laminosas e espinhos. Chamada de “apragata” nos currais e em
                seus arredores, a sandália usada na lida com o gado já era
                forte, embora não propriamente valente.
              </p>
            </S.Column>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Imprescindível para uma sociedade nômade, que se deslocava a pé,
                como a de Lampião e seu bando, a tal valentia seria alcançada no
                ciclo do cangaço, como confirmam as sucessoras da alpercata de
                couro e sola, a alpercata ferrada e a alpercata parabelo. Nas
                duas versões, há a tentativa de obter mais resistência.
                “Comparada com o esguio do sapato litorâneo, a alpercata ferrada
                parecia uma raquete. Espalhada. Feia. Mas, fosse o freguês andar
                na caatinga e se deparasse com um daqueles vastos bancos de
                macambira, logo iria saber a razão da raquete do cangaceiro”,
                explica o pesquisador Frederico Pernambucano de Mello no livro{" "}
                <i>Estrelas de couro – A estética do cangaço.</i>
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
      <S.WrapperPhoto>
        <S.Photo2
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
        <S.Photo2Legend>
          Página do livro <i>Estrelas de couro - A estética do cangaço</i>
        </S.Photo2Legend>
      </S.WrapperPhoto>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Dimensão
            <br />
            épica
          </S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                A caminhada era lenta, silenciosa. Às vezes, o bando tinha de
                rastejar. Ao sabor de cantorias, causos e folhetos de cordel,
                que ecoavam heroísmo e aventura, o cangaço estabeleceu uma
                estética própria em sua interação com a caatinga e com a ordem
                social do semiárido nordestino.
              </p>

              <p>
                No plano da indumentária, acessórios e vestimentas precisavam
                contar histórias e transmitir a dimensão épica dos feitos do
                cangaceiro. Anéis e medalhas denotariam, por exemplo, o ar de
                nobreza, a fragrância da fidalguia. Aplicadas no chapéu de
                couro, estrelas e moedas garantiam proteção e ventura, enquanto
                a fluidez dos lenços coloridos se prestava a amenizar asperezas.
              </p>
            </S.Column>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Facínora, justiceiro, Robin Hood dos pobres. Figura mítica que
                causava admiração e repulsa, Lampião talvez tenha sido mesmo o
                responsável pela permanência do design da xô boi, já que as
                exigências do mais notório dos cangaceiros resultaram no
                aperfeiçoamento funcional e visual da sandália. Nessa espécie de
                elaboração popular, a peça teve sua correia horizontal reforçada
                na largura e sua abertura frontal redimensionada. “Na ponta, o
                segredo de seu prestígio no sertão sobre outras concepções de
                calçados: pequena abertura frontal, a janela, responsável pela
                refrigeração do pé no chão quente da caatinga”, explica
                Frederico Pernambucano. Nos meses mais secos, a temperatura do
                solo no semiárido nordestino pode atingir 60º C.{" "}
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
      <S.Photo3>
        <S.WrapperPhotoLegend>
          <S.Photo3Legend>
            Xô Boi do Mestre Espedito Seleiro. Foto: Waldemar Cunha
          </S.Photo3Legend>
        </S.WrapperPhotoLegend>
      </S.Photo3>
      <S.Photo3Mobile
        className="wow animate__animated animate__zoomIn"
        data-wow-duration="1s"
      />
      <S.Photo3LegendMobile>
        Xô Boi do Mestre Espedito Seleiro.
        <br />
        Foto: Waldemar Cunha
      </S.Photo3LegendMobile>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="300ms"
          >
            Forma
            <br />e função
          </S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Se design consiste em conectar forma e função, a xô boi pode ser
                considerada uma campeã. Poucos calçados transitaram tão bem
                entre passado, presente e futuro, com a força de seu desenho a
                permitir que a imaginação de artistas e designers contemporâneos
                se apropriasse de uma fórmula tão vigorosa, a ponto de
                atravessar séculos. A apropriação que vai um passo além da
                tradição orgânica a que se liga Espedito Seleiro, e que imprimiu
                à sandália formatos mais anatômicos e texturas
                multidimensionais, está, por exemplo, nas peças confeccionadas
                pela artista multiversa alagoana Julia Maria Nogueira, 34 anos.
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
      <S.WrapperPhoto>
        <S.Photo4
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        />
        <S.Photo4Legend>Ser'tão Encantado</S.Photo4Legend>
      </S.WrapperPhoto>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title className="empty">{"  "}</S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                Criadora da Ser’tão Encantado, marca que enaltece a cultura
                sertaneja, Julia conheceu a xô boi ainda criança, nos pés de seu
                avô. “Eu sou nordestina, sempre usei xô boi, e tinha uma relação
                muito forte com o meu avô, que usava xô boi também”, conta.
                “Cresci com isso dentro de mim, até fazer uma viagem para o
                sertão, sozinha, e me deparar com toda a riqueza da arte e da
                cultura que o sertão traz. Saí de lá com o desejo de cantar o
                sertão pelos lugares a que eu fosse, de tirá-lo do lugar de
                sofrimento e de miséria e colocá-lo no lugar que ele também
                existe, de alegria, de cor, de felicidade, de originalidade.”
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
      <S.Photo5>
        <S.WrapperPhotoLegend>
          <S.Photo5Legend>Ser'tão Encantado</S.Photo5Legend>
        </S.WrapperPhotoLegend>
      </S.Photo5>
      <S.Photo5Mobile
        className="wow animate__animated animate__zoomIn"
        data-wow-duration="1s"
      />
      <S.Photo5LegendMobile>Ser'tão Encantado</S.Photo5LegendMobile>
      <S.Content>
        <S.WrapperAllTexts>
          <S.Title className="empty">{"  "}</S.Title>
          <S.WrapperColumns>
            <S.Column
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="300ms"
            >
              <p>
                A xô boi que surge no catálogo da marca é uma explosão de cores,
                um convite ao caminhar, um painel entretempos que exala tradição
                e contemporaneidade. “Eu sou muito feliz de ver que esse
                universo vem tomando conta de olhares, do desejo das pessoas.
                Hoje, minha marca é vendida para o Brasil inteiro e até para
                fora do país, e o produto que mais tem giro é a xô boi”, explica
                Julia. Na base do trabalho, o homem da caatinga, a cultura
                sertaneja, o semiárido, o povo. “Trabalho com artistas da minha
                terra. A confecção é toda feita manualmente aqui. Eu poderia,
                sim, reproduzir as peças em fábricas de couro, mas essa não é a
                essência nem o propósito do meu trabalho.”
              </p>
            </S.Column>
          </S.WrapperColumns>
        </S.WrapperAllTexts>
      </S.Content>
    </S.Container>
  );
};
